import { combineReducers } from 'redux'
import login from './login'
import retailer from './retailer'
import diamond from './diamond'
import form from './form'
import image from './image'
import navigation from './navigationSlice'

export default combineReducers({
  login,
  retailer,
  diamond,
  form,
  image,
  navigation,
})
